import { render, staticRenderFns } from "./MeetingVideoHolderCard.vue?vue&type=template&id=c763c078&scoped=true&"
import script from "./MeetingVideoHolderCard.vue?vue&type=script&lang=js&"
export * from "./MeetingVideoHolderCard.vue?vue&type=script&lang=js&"
import style0 from "./MeetingVideoHolderCard.vue?vue&type=style&index=0&id=c763c078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c763c078",
  null
  
)

export default component.exports